import { Pipe, PipeTransform } from '@angular/core';
import { StateService } from '../state/state.service';
import { ApiUser } from '../models/Profile.model';

@Pipe({
    name: 'access',
    standalone: false
})
export class AccessPipe implements PipeTransform {
  transform(user: ApiUser, access: string): boolean {
    const permissions = user?.permissions;
    if (!permissions) {
      return false;
    }

    if (permissions.includes('ADMIN') && access !== 'OWNER') {
      return true;
    }
    return permissions.includes(access.toUpperCase());
  }
}
